/**
 * Generated by orval v7.9.0 🍺
 * Do not edit manually.
 * Meeting BaaS API
 * API for managing meeting bots, calendar integrations, and webhooks
 * OpenAPI spec version: 2.0.0
 */

/**
 * The current transcription status
 */
export type GetBotStatusResponseInputDataTranscriptionStatus =
  (typeof GetBotStatusResponseInputDataTranscriptionStatus)[keyof typeof GetBotStatusResponseInputDataTranscriptionStatus]

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const GetBotStatusResponseInputDataTranscriptionStatus = {
  queued: "queued",
  processing: "processing",
  done: "done",
  error: "error",
  "not-applicable": "not-applicable",
  "not-started": "not-started"
} as const
